import { useRef, useEffect, useState, useContext } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { Button, ThemeContext } from '@forma/forma-ui-kit';
import RequestSettingModal from '@/components/blocks/RequestSettingModal';

import styles from './request-setting-panel.module.css';

const RequestSettingPanel = () => {
  const blockRef = useRef(null);
  const { pathname } = useRouter();
  const { viewport } = useContext(ThemeContext);
  const [isShow, setShow] = useState(false);
  const [isVisible, setVisible] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSuccess, setSuccess] = useState(false);

  const isPhone = ['phone'].includes(viewport);

  const handleScrollTop = () => {
    if (!blockRef.current) return;
    const scrollTop = window.scrollY;
    const screenHeight = window.innerHeight;
    if (scrollTop + screenHeight > blockRef.current.offsetTop) setVisible(true);
    else setVisible(false);
  };

  useEffect(() => {
    blockRef.current = document.getElementById('cards');
  }, [pathname]);

  useEffect(() => {
    if (!localStorage.getItem('lp_setting_request')) setShow(true);

    blockRef.current = document.getElementById('cards');

    document.addEventListener('scroll', handleScrollTop);

    return () => {
      document.removeEventListener('scroll', handleScrollTop);
    };
  }, []);

  const allowInRoute = ['/[locale]', '/[locale]/sign'].includes(pathname) || pathname.startsWith('/[locale]/solutions');

  const handleSuccess = () => {
    localStorage.setItem('lp_setting_request', 1);
    setSuccess(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    if (isSuccess) setShow(false);
  };

  if (!isShow || !allowInRoute || isPhone) return null;

  return (
    <div className={classNames(styles.root, isVisible && styles.visible)}>
      <div className={classNames(styles.container, 'container')}>
        <div className={styles.left}>
          <img className={styles.image} src="/images/files-icons.svg" width={91} height={57} alt="Files Icons" />
          <div className={styles.content}>
            <div className={styles.title}>Настроим первый шаблон</div>
            <div className={styles.description}>
              Загрузите любой из ваших наиболее используемых документов и получите
              готовый шаблон для автоматизированного создания ваших будущих документов.
            </div>
          </div>
        </div>
        <div className={styles.buttons}>
          <Button
            onClick={() => setModalOpen(true)}
            className={styles.button}
          >
            Создать 1-й шаблон
          </Button>
        </div>
      </div>
      <RequestSettingModal open={isModalOpen} onClose={handleClose} onSuccess={handleSuccess} />
    </div >
  );
};

export default RequestSettingPanel;
